import * as clone from 'clone'
import { CampaignModel } from '../models/campaign/campaign.model'
import { CampaignRevision } from '../models/campaign/campaign-revision'
import { CampaignStep } from '../models/campaign/campaign-step'
import { StepType } from '@pushly/models/lib/enums/journeys'
import { generateShortID } from './uid'
import { TriggerType } from '@pushly/models/lib/enums'

export const extractCampaignTrigger = (campaign: CampaignModel): CampaignStep => {
    const rev = campaign.getCurrentRevision() ?? CampaignRevision.build({})
    const steps = rev.getSteps()
    const triggerIdx = steps.findIndex((s) => s.getType() === StepType.TRIGGER)
    return steps[triggerIdx]
}

export function isTriggerTypeOf(trigger: TriggerType, types: TriggerType | TriggerType[]): boolean {
    types = Array.isArray(types) ? types : [types]
    return types.includes(trigger)
}

export function reassignStepIds(steps: any[]): any[] {
    const reassigned = clone(steps)
    const updatedIdMap: any = {}

    reassigned.forEach((s) => {
        const newId = generateShortID()
        updatedIdMap[s.id] = newId
        s.id = newId
    })

    reassigned.forEach((s) => {
        if (!!s.configuration?.out_step_id) {
            s.configuration.out_step_id = updatedIdMap[s.configuration.out_step_id]
        }
    })

    return reassigned
}
